import React from 'react';
import { FC } from 'react';
import CheckboxStyles from './CheckBoxStyle.module.css';

type CheckboxProps = {
  name?: string;
  label?: string;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  errorMessage?: string;
  containerStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  checkboxStyle?: React.CSSProperties;
  labelClass?: string;
  hideCheckbox?:boolean
};

const CheckboxInput: FC<CheckboxProps> = ({ name, label, checked, onChange, disabled, errorMessage, containerStyle, labelStyle, checkboxStyle, labelClass,hideCheckbox }) => {
  return (
    <div className={CheckboxStyles.form_input} style={containerStyle}>
      <label className={`${CheckboxStyles.form_input__label} ${labelClass || ''}`} style={labelStyle}>
        <input
          type='checkbox'
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        className={`${CheckboxStyles.form_input__checkbox} ${hideCheckbox ? CheckboxStyles.hiddenCheckbox : ''}`}
          style={checkboxStyle}
        />
        {label}
      </label>
      {errorMessage && <p className={CheckboxStyles.form_input__error}>{errorMessage}</p>}
    </div>
  );
};

export default CheckboxInput;
